// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1gxUa","fadeIn":"Footer_fadeIn__3ZZlj","scaleXin":"Footer_scaleXin__Hzdw5"};